import { useTranslation } from '@mc/i18n'
import { GiftButton } from '@mc/promos'
import { getPageSource, Locations, PageSource } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import CTA from 'components/CTA'
import { trackValuePropViewed } from 'components/ValueProps'
import { ValuePropsList } from './ValuePropsList'

export const Subscription = ({
  eventProps = {},
}: {
  eventProps?: Record<string, string | number | undefined>
}) => {
  const { t } = useTranslation('@mc/next')

  const pageSource = getPageSource()

  const location =
    pageSource === PageSource.HOMEPAGE
      ? Locations.WHAT_YOU_WILL_GET
      : Locations.WHATS_INCLUDED

  const trackProps = {
    location,
    category: 'whats-included',
    page_source: pageSource,
    ...eventProps,
  }

  return (
    <TrackingContainer onFirstVisible={trackValuePropViewed}>
      <section
        className='container mc-my-10'
        data-testid='subscription'
        id='whats-included'
      >
        <div className='row align-items-center'>
          <div className='col-12 col-lg-6 mc-text--center mc-text-lg--left'>
            <h2 className='mc-text-h2'>{t('subscription.title')}</h2>
            <div className='mc-mt-6'>
              <div className='d-flex justify-content-center justify-content-lg-start'>
                <div className='col-6 col-sm-4'>
                  <CTA fullWidth trackProps={trackProps} />
                </div>
                <div className='col-6 col-sm-4'>
                  <GiftButton location={location} />
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-lg-5 offset-lg-1 d-flex justify-content-center'>
            <ValuePropsList />
          </div>
        </div>
      </section>
    </TrackingContainer>
  )
}
